/**
 * Marca as caixas .image com a classe -loaded quando a imagem termina de carregar
 * (equivalente à classe "loaded" que o lazyload do tema anterior aplicava), para esconder o skeleton.
 * Funciona com loading="lazy" nativo e com conteúdo trocado por Section Rendering (evento load em captura).
 */
function markLoaded(img) {
  const box = img.closest('.image');
  if (box) box.classList.add('-loaded');
}

function scan(root = document) {
  root.querySelectorAll('.image img').forEach((img) => {
    if (img.complete && img.naturalWidth > 0) markLoaded(img);
  });
}

document.addEventListener(
  'load',
  (event) => {
    if (event.target instanceof HTMLImageElement) markLoaded(event.target);
  },
  true
);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => scan());
} else {
  scan();
}

document.addEventListener('shopify:section:load', (event) => scan(event.target));
